import "../pages.scss"
import { VisitasState } from '../../context/visitas/VisitasState';
import { EmpleadosState } from '../../context/empleados/EmpleadosState';
import Datatable from "./visitasTable/RutasDatatable"

const VisitasMapsPage = () => {
    return (
        <>
            <VisitasState>
                <EmpleadosState>
                    <Datatable />
                </EmpleadosState>
            </VisitasState>

        </>
    )
}

export default VisitasMapsPage